module.exports = __webpack_public_path__ + "a0dd9cd93306bbe77b88c7abdeca551e.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/broschuere21_image.jpg
// module id = 608
// module chunks = 0